import { __rest } from 'tslib';
import React from 'react';
import RcDrawer from 'rc-drawer';
import { ConfigContext } from 'antd-core/es/config-provider';
import useStyle from 'antd-core/es/drawer/style';
import { getTransitionName } from 'antd-core/es/_util/motion';
import { useColor } from '@10d/tend-ui-theme';
import { DrawerContext } from '../../contexts/DrawerContext.js';

const FULLSCREEN_OFFSET = '0px';
const Root = (_a) => {
    var { open, maskClosable, mask, fullscreen, size = 'medium', placement = 'right', onClose, children, destroyOnClose, backgroundColor } = _a, props = __rest(_a, ["open", "maskClosable", "mask", "fullscreen", "size", "placement", "onClose", "children", "destroyOnClose", "backgroundColor"]);
    const { getPrefixCls } = React.useContext(ConfigContext);
    const prefixCls = getPrefixCls('drawer');
    const [, hashId] = useStyle(prefixCls);
    // FIXME: Исправить литеральные типы
    const _backgroundColor = useColor(backgroundColor);
    const fullscreenOffset = (() => {
        var _a;
        if (typeof fullscreen === 'object')
            return (_a = fullscreen === null || fullscreen === void 0 ? void 0 : fullscreen.offset) !== null && _a !== void 0 ? _a : FULLSCREEN_OFFSET;
        return FULLSCREEN_OFFSET;
    })();
    const isTop = placement === 'top';
    const isBottom = placement === 'bottom';
    const isLeft = placement === 'left';
    const isRight = placement === 'right';
    const isVertical = isTop || isBottom;
    const isHorizontal = isLeft || isRight;
    const maskMotion = React.useMemo(() => ({
        motionName: getTransitionName(prefixCls, 'mask-motion'),
        motionAppear: true,
        motionEnter: true,
        motionLeave: true,
        motionDeadline: 500,
    }), [prefixCls]);
    const panelMotion = React.useCallback(motionPlacement => ({
        motionName: getTransitionName(prefixCls, `panel-motion-${motionPlacement}`),
        motionAppear: true,
        motionEnter: true,
        motionLeave: true,
        motionDeadline: 500,
    }), [prefixCls]);
    const width = React.useMemo(() => {
        if (fullscreen && isHorizontal)
            return `calc(100% - ${fullscreenOffset})`;
        return {
            small: '400px',
            medium: '500px',
            large: '800px',
        }[size];
    }, [fullscreen, fullscreenOffset, isHorizontal, size]);
    const height = React.useMemo(() => {
        if (fullscreen && isVertical)
            return `calc(100% - ${fullscreenOffset})`;
        return;
    }, [fullscreen, fullscreenOffset, isVertical]);
    return (React.createElement(RcDrawer, Object.assign({ open: open, mask: mask, maskClosable: maskClosable, onClose: onClose, prefixCls: prefixCls, rootClassName: hashId, maskMotion: maskMotion, motion: panelMotion, width: width, height: height, placement: placement, destroyOnClose: destroyOnClose, styles: React.useMemo(() => ({
            content: {
                display: 'flex',
                flexDirection: 'column',
                maxHeight: '100vh',
                backgroundColor: _backgroundColor,
            },
        }), [_backgroundColor]) }, props),
        React.createElement(DrawerContext.Provider, { value: React.useMemo(() => ({ onClose }), [onClose]) }, children)));
};
Root.displayName = 'Drawer.Root';

export { Root };
